import { HttpClient } from 'shared/libs/http';
import { PlansListPurchaseResponse } from './types';

export class EmployerApiService {
   public static plansListPurchase() {
      return HttpClient.get<PlansListPurchaseResponse>('/plans/listPurchase');
   }
}
